import * as _ from 'lodash';
import {Serializable} from '../deserialize.service';

export class Case implements Serializable<Case> {
    bsid: number;
    caseId: string;
    caseInternalId: number;
    wqid: number;
    deserialize(input) {
        if (_.isNil(input)) {
            return undefined;
        }
        this.wqid = input.wqid;
        this.bsid = input.bsid;
        this.caseId = input.caseId;
        this.caseInternalId = input.caseInternalId;

        return this;
    }
}
